"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@angular/common");
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
const idm_filtering_controls_1 = require("@synisys/idm-filtering-controls");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const idm_um_client_js_1 = require("@synisys/idm-um-client-js");
const ng2_dragula_1 = require("ng2-dragula");
const material_module_1 = require("../../material.module");
const me_services_module_1 = require("../../shared/me-services.module");
const pipe_module_1 = require("../../shared/pipe.module");
const common_settings_module_1 = require("../shared/common-settings.module");
const page_filter_builder_component_1 = require("./builder/page-filter-builder.component");
const page_filter_component_1 = require("./page-filter.component");
const boolean_filter_component_1 = require("./simple-components/boolean-filter/boolean-filter.component");
const category_filter_component_1 = require("./simple-components/category-filter/category-filter.component");
const date_filter_component_1 = require("./simple-components/date-filter/date-filter.component");
const number_filter_component_1 = require("./simple-components/number-filter/number-filter.component");
const text_filter_component_1 = require("./simple-components/text-filter/text-filter.component");
const page_filter_view_component_1 = require("./view/page-filter-view.component");
/**
 * Created by mariam.melkonyan on 5/26/17.
 */
let PageFilterModule = class PageFilterModule {
};
PageFilterModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            idm_ng_controls_1.ControlsModule,
            forms_1.FormsModule,
            material_module_1.MaterialModule,
            pipe_module_1.PipeModule,
            forms_1.ReactiveFormsModule,
            common_settings_module_1.CommonSettingsModule,
            ng2_dragula_1.DragulaModule,
            idm_entity_search_client_js_1.EntitySearchModule,
            me_services_module_1.MEServicesModule,
            idm_filtering_controls_1.FilteringControlsModule
        ],
        declarations: [
            page_filter_component_1.PageFilterComponent,
            page_filter_builder_component_1.PageFilterBuilderComponent,
            page_filter_view_component_1.PageFilterViewComponent,
            boolean_filter_component_1.BooleanFilterComponent,
            text_filter_component_1.TextFilterComponent,
            number_filter_component_1.NumberFilterComponent,
            date_filter_component_1.DateFilterComponent,
            category_filter_component_1.CategoryFilterComponent
        ],
        exports: [
            page_filter_component_1.PageFilterComponent,
            page_filter_builder_component_1.PageFilterBuilderComponent,
            page_filter_view_component_1.PageFilterViewComponent,
            boolean_filter_component_1.BooleanFilterComponent,
            text_filter_component_1.TextFilterComponent,
            number_filter_component_1.NumberFilterComponent,
            date_filter_component_1.DateFilterComponent,
            category_filter_component_1.CategoryFilterComponent
        ],
        providers: [
            { provide: idm_um_client_js_1.UserService, useClass: idm_um_client_js_1.HttpUserService }
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA],
    })
], PageFilterModule);
exports.PageFilterModule = PageFilterModule;
//# sourceMappingURL=page-filter.module.js.map